import { Badge } from "@/components/ui/badge";

interface WorkflowBadgeProps {
  isActive: boolean;
  children: React.ReactNode;
}

export const WorkflowBadge = ({ isActive, children }: WorkflowBadgeProps) => (
  <Badge
    variant={isActive ? "default" : "outline"}
    className={`${isActive ? "bg-primary text-white" : "text-primary"} text-xs sm:text-sm`}
  >
    {children}
  </Badge>
);